module.exports = __webpack_public_path__ + "img/user-dashboard.b047d524.svg";